<template>
  <div class="r-text-body-small">
    <span>לא נרשמת בעבר? </span>
    <link-button text="כאן אפשר להירשם" @click="goToSignup"/>
  </div>
</template>

<script>

import LinkButton from '@/components/base/LinkButton';
import { SIGNUP_FIRST_PAGE } from '@/router/consts';

export default {
  name: 'GoToSignup',
  components: { LinkButton },
  methods: {
    goToSignup() {
      this.$router.push(SIGNUP_FIRST_PAGE);
    },
  },

};
</script>
